<div class="login-container">
  <div class="login-card">
    <div class="login-left-panel">
      <div class="login-top">
        <img src="../assets/images/tracksure-01.png" class="logoImg" alt="TrackSure Logo" />
      </div>
      <div class="login-bottom">
        <img src="../assets/images/login-bg.png" alt="Login Background" />
      </div>
    </div>
    <div class="login-right-panel">
      <div class="login-form">
        <div class="form-title">{{showRegister ? 'Register' : 'Login'}}</div>
        <div class="form-label">Enter your user ID and password to log in to your account</div>
        <form>
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>User ID</mat-label>
            <input matInput [(ngModel)]="user_id" name="user_id" placeholder="User ID" maxlength="30">
            <mat-hint align="end">{{user_id?.length || 0}}/30</mat-hint>
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-group mt-3">
            <mat-label>Password</mat-label>
            <input matInput [type]="hidePassword ? 'password' : 'text'" [(ngModel)]="password" name="password"
              placeholder="Password" maxlength="20" (focus)="onHandlePasswordFocus()" (blur)="onHandlePasswordBlur()"
              (ngModelChange)="onPasswordChange(password)">
            <div mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hidePassword">
              <mat-icon class="cursor">{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </div>
            <mat-hint *ngIf="is_password_suggestion_message">
              <span>Password contains </span>,
              <span [class.green-text]="is_password_suggestion_alphabet">alphabets</span>,
              <span [class.green-text]="is_password_suggestion_number">numbers</span> and
              <span [class.green-text]="is_password_suggestion_special_character">special characters.</span>
            </mat-hint>
            <mat-hint align="end">{{ password?.length || 0 }}/20</mat-hint>
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-group mt-3" *ngIf="showRegister">
            <mat-label>Confirm Password</mat-label>
            <input matInput [type]="hideReTypePassword ? 'password' : 'text'" placeholder="Confirm Password"
              (ngModelChange)="matchPassword($event);"
              [ngModel]="reTypePasswordValue" name="reTypePassword" maxlength="20">
            <div mat-icon-button matSuffix (click)="hideReTypePassword = !hideReTypePassword"
              [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideReTypePassword">
              <mat-icon class="cursor">{{hideReTypePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </div>
            <mat-hint *ngIf="showError" class="red">{{is_confirm_password_not_match}}</mat-hint>
            <mat-hint align="end">{{ reTypePasswordValue.length || 0 }}/20</mat-hint>
          </mat-form-field>
          <div class="form-group">
            <button type="button" class="login-button" (click)="login(user_id,password)"
              *ngIf="!showRegister">Login</button>
            <button type="button" class="login-button" (click)="register(user_id,password)"
              *ngIf="showRegister">Register</button>
            <div class="option-text mb-3 mt-2" *ngIf="!showRegister" (click)="onRegister()">New User Registration?</div>
            <div class="option-text mt-2" *ngIf="showRegister" (click)="onRegister()">Login?</div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>